import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
const benefits = [{
  number: "01",
  title: "Gain de temps",
  description: "Externalisez la phase chronophage des livraisons. Nos experts prennent en charge la planification, l'accueil, les visites et la gestion administrative libérant vos équipes pour se concentrer sur la valeur ajoutée de leurs propres tâches."
}, {
  number: "02",
  title: "Professionnalisation",
  description: "Renforcez votre image de marque avec un processus de livraison structuré et rigoureux. Nous apportons une méthodologie éprouvée qui transforme cette étape technique critique en un véritable atout de qualité perçue."
}, {
  number: "03",
  title: "Réduction des litiges",
  description: "Sécurisez vos opérations grâce à une approche précise et technique des réserves. Notre expertise permet d'anticiper les points de friction, de qualifier précisément les désordres et d'accélérer les levées de réserves."
}, {
  number: "04",
  title: "Satisfaction acquéreurs",
  description: "Offrez une expérience client d'excellence lors de la remise des clés. Un accompagnement humain, pédagogique et rassurant qui valorise votre produit et fidélise vos clients pour vos futurs programmes."
}];
export default function StrategicBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="bénéfices-stratégiques" ref={ref} className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" aria-hidden="true">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#808080_1px,transparent_1px),linear-gradient(to_bottom,#808080_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className={cn("max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl md:text-4xl font-sans font-bold tracking-tight mb-6">
            Pourquoi externaliser vos livraisons ?
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Une approche stratégique pour optimiser la fin de chantier et garantir la réussite de vos opérations immobilières.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-border/30">
          {benefits.map((benefit, index) => <div key={index} data-index={index} className={cn("group relative p-8 md:p-12 border-b border-r border-border/30 bg-card/5 hover:bg-card/10 transition-colors duration-500", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
          transitionDelay: `${index * 150}ms`
        }}>
              <div className="flex flex-col h-full justify-between gap-6">
                <div className="space-y-6">
                  <span className="block text-6xl md:text-7xl font-mono font-light text-primary/90 tracking-tighter opacity-80 group-hover:opacity-100 transition-opacity">
                    {benefit.number}
                  </span>
                  <h3 className="text-2xl font-sans font-semibold tracking-tight text-foreground group-hover:text-primary transition-colors">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {}
        <div className={cn("mt-16 text-center transition-all duration-700 delay-500 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <Button asChild size="lg" className="text-base px-8 py-6 h-auto rounded-none">
            <Link to="/ContactPage">
              Confiez-nous vos livraisons
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}